export default __webpack_public_path__ + "static/app-buyer-guide-5d535818fd78d50b84273fbda3ee1490.svg";